import { useScroll } from 'framer-motion';
// @mui

// components
import ScrollProgress from 'src/components/scroll-progress';
import HomeHero from '../home-hero';
import HomeFeatures from '../home-features';
import HomeTestimonials from '../home-testimonials';
import HomeLogos from '../home-logos';
import HomeCTA from '../home-cta';

// ----------------------------------------------------------------------

export default function HomeView() {
  const { scrollYProgress } = useScroll();

  return (
    <>
      <ScrollProgress scrollYProgress={scrollYProgress} />

      <HomeHero />

      <HomeFeatures />

      <HomeTestimonials />

      <HomeLogos />

      <HomeCTA />
    </>
  );
}
